import {Component, forwardRef} from "@angular/core";
import {SearchModel} from "@fedeltapointofsale/data-client";
import {FUIAlertAction, FUIAlertActions, FUIAlertService} from "@fedeltapointofsale/ui";
import {
    SearchAction,
    SearchActionSelector
} from "../../../framework/entity/search/search-grid/actions/search-action.component";
import {MyreportRunNowAction, MyreportRunNowService} from "../myreport-run-now.service";
import {firstValueFrom} from "rxjs";

/**
 * SearchAction to run now a myreport
 */
@Component({
    selector: "wbo-myreport-run-now-search-action",
    template: "",
    providers: [
        {
            provide: SearchActionSelector,
            useExisting: forwardRef(() => MyreportRunNowSearchActionComponent),
            multi: true
        },
        MyreportRunNowService
    ]

})
export class MyreportRunNowSearchActionComponent implements SearchAction {

    constructor(private alertService: FUIAlertService,
                private searchModel: SearchModel<any>,
                private service: MyreportRunNowService) {
    }

    /**
     *
     * @returns {number}
     */
    getImportance(): number {
        return 40;
    }

    /**
     *
     * @param data
     * @returns {string}
     */
    getIcon(data: any): string {
        return "play-badge";
    }

    getIconClass(data: any): string {
        return "";
    }

    getIconSize(data: any): number {
        return 17;
    }

    getName(data: any): string {
        return "wbo.myreport.search.action.runNow";
    }

    async doAction(data: any): Promise<void> {
        const action: FUIAlertAction = await firstValueFrom(this.alertService.showConfirmationOkCancel("wbo.myreport.search.prompt.runNow.heading", "wbo.myreport.search.prompt.runNow.message"));
        if (action === FUIAlertActions.OK_ACTION) {
            await this.service.performAction(new MyreportRunNowAction(data["myreportId"]));
            await firstValueFrom(this.alertService.showInformation("wbo.myreport.search.prompt.executingReport.heading", "wbo.myreport.search.prompt.executingReport.message"));
        }
    }

    isAvailable(data: any): boolean {
        return true;
    }
}
